import { FunctionComponent } from 'react';
import { createPortal } from 'react-dom';
import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import { DownloadAppModal } from '../../components';
import { ConfigContext } from '../../context';
import { useGetConfigQuery } from '../../services';
import { ScrollToTop, getOrganisationDomain, useConfig } from '../../shared';

export const FormLayout: FunctionComponent = () => {
  const { data: config } = useGetConfigQuery({ organisationDomain: getOrganisationDomain() });

  useConfig(config);

  if (!config) {
    return null;
  }

  const { title, faviconUrl } = config.elements.meta;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <link rel={'icon'} href={faviconUrl} />
      </Helmet>

      <ScrollToTop />

      <ConfigContext.Provider value={{ config }}>
        <Outlet />
        <DownloadAppModal />
      </ConfigContext.Provider>

      {createPortal(
        <ToastContainer
          autoClose={2000}
          position={'bottom-center'}
          transition={Slide}
          newestOnTop
          hideProgressBar={true}
          pauseOnHover={false}
          draggable={false}
          style={{ zIndex: 999999 }}
        />,
        document.getElementById('toast-root') as HTMLElement
      )}
    </>
  );
};
